var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 41,
    viewBox: "0 0 21 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1169_3558)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1169_3558",
    maskUnits: "userSpaceOnUse",
    x: -0.0498047,
    y: 1,
    width: 21,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.0498047,
    y: 1,
    width: 21,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0502 11.1C19.0502 15.5735 15.2222 19.2 10.5002 19.2C9.41961 19.2 8.38585 19.0101 7.43407 18.6636L2.99497 21L3.67613 15.9808C2.59277 14.6235 1.9502 12.9328 1.9502 11.1C1.9502 6.62649 5.77816 3 10.5002 3C15.2222 3 19.0502 6.62649 19.0502 11.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.43407 18.6636L7.94721 17.2541C7.54978 17.1094 7.10973 17.1392 6.73545 17.3362L7.43407 18.6636ZM2.99497 21L1.50859 20.7982C1.43306 21.3548 1.67477 21.9069 2.13492 22.2289C2.59508 22.5509 3.19658 22.5889 3.69359 22.3273L2.99497 21ZM3.67613 15.9808L5.16251 16.1825C5.21763 15.7764 5.10416 15.3654 4.84848 15.0451L3.67613 15.9808ZM10.5002 20.7C15.9732 20.7 20.5502 16.4773 20.5502 11.1H17.5502C17.5502 14.6697 14.4713 17.7 10.5002 17.7V20.7ZM6.92092 20.0731C8.0357 20.4789 9.24305 20.7 10.5002 20.7V17.7C9.59618 17.7 8.736 17.5413 7.94721 17.2541L6.92092 20.0731ZM3.69359 22.3273L8.13269 19.991L6.73545 17.3362L2.29635 19.6726L3.69359 22.3273ZM2.18976 15.7791L1.50859 20.7982L4.48134 21.2017L5.16251 16.1825L2.18976 15.7791ZM0.450195 11.1C0.450195 13.2919 1.22051 15.3088 2.50378 16.9166L4.84848 15.0451C3.96503 13.9382 3.4502 12.5737 3.4502 11.1H0.450195ZM10.5002 1.5C5.02718 1.5 0.450195 5.72268 0.450195 11.1H3.4502C3.4502 7.5303 6.52914 4.5 10.5002 4.5V1.5ZM20.5502 11.1C20.5502 5.72268 15.9732 1.5 10.5002 1.5V4.5C14.4713 4.5 17.5502 7.5303 17.5502 11.1H20.5502Z",
    fill: "#0070D2",
    mask: "url(#path-1-outside-1_1169_3558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 7.5V12",
    stroke: "#0070D2",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4996 15.6C10.9967 15.6 11.3996 15.1971 11.3996 14.7C11.3996 14.203 10.9967 13.8 10.4996 13.8C10.0026 13.8 9.59961 14.203 9.59961 14.7C9.59961 15.1971 10.0026 15.6 10.4996 15.6Z",
    fill: "#0070D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53516 36H5.07031V32.9531H2.21387V36H0.749023V28.8906H2.21387V31.7715H5.07031V28.8906H6.53516V36ZM10.1582 36.0977C9.38346 36.0977 8.75195 35.86 8.26367 35.3848C7.77865 34.9095 7.53613 34.2764 7.53613 33.4854V33.3486C7.53613 32.818 7.63867 32.3444 7.84375 31.9277C8.04883 31.5078 8.33854 31.1855 8.71289 30.9609C9.09049 30.7331 9.52018 30.6191 10.002 30.6191C10.7246 30.6191 11.2926 30.847 11.7061 31.3027C12.1227 31.7585 12.3311 32.4046 12.3311 33.2412V33.8174H8.9668C9.01237 34.1624 9.14909 34.4391 9.37695 34.6475C9.60807 34.8558 9.89941 34.96 10.251 34.96C10.7946 34.96 11.2194 34.763 11.5254 34.3691L12.2188 35.1455C12.0072 35.445 11.7207 35.6794 11.3594 35.8486C10.998 36.0146 10.5977 36.0977 10.1582 36.0977ZM9.99707 31.7617C9.71712 31.7617 9.48926 31.8561 9.31348 32.0449C9.14095 32.2337 9.03027 32.5039 8.98145 32.8555H10.9443V32.7432C10.9378 32.4307 10.8532 32.1898 10.6904 32.0205C10.5277 31.848 10.2965 31.7617 9.99707 31.7617ZM14.626 36H13.21V28.5H14.626V36ZM20.5488 33.4072C20.5488 34.221 20.3633 34.8737 19.9922 35.3652C19.6243 35.8535 19.1263 36.0977 18.498 36.0977C17.9642 36.0977 17.5329 35.9121 17.2041 35.541V38.0312H15.793V30.7168H17.1016L17.1504 31.2344C17.4922 30.8242 17.9382 30.6191 18.4883 30.6191C19.1393 30.6191 19.6455 30.86 20.0068 31.3418C20.3682 31.8236 20.5488 32.4876 20.5488 33.334V33.4072ZM19.1377 33.3047C19.1377 32.8132 19.0498 32.4339 18.874 32.167C18.7015 31.9001 18.4492 31.7666 18.1172 31.7666C17.6745 31.7666 17.3701 31.9359 17.2041 32.2744V34.4375C17.3766 34.7858 17.6842 34.96 18.127 34.96C18.8008 34.96 19.1377 34.4082 19.1377 33.3047Z",
    fill: "#0070D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1169_3558",
    x: 0,
    y: 0.75,
    width: 21,
    height: 40.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1169_3558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1169_3558",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.91a23fdaf971013eb0b04d66b3a5c84b.svg";
export { ForwardRef as ReactComponent };